module.exports = "agm-map {\n  display: block;\n  width: calc(100vw - 400px);\n  height: calc(100vh - 100px); }\n"